import { EventManager } from "@core/managers/event.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { UserStorageManager } from "@core/managers/user-storage.manager";
import { TEMPLATE_CREATION_STEPS } from "@core/constants";
import { RecruitmentDashboardModel } from "@core/models";
import { CreationDemandService } from "@core/services";
import { ETAB_ROUTES } from "@etab/config";
import { ETAB_EVENTS } from "../config";

export const dashboardDemandMixin = {
  computed: {
    $_avatarSize() {
      return "36px";
    },
    $_colors() {
      return {
        primary: "#072c55",
        secondary: "#ff2c55",
        third: "#FF5E00",
        interim: "#2F9656",
        success: "#3bbc6c",
        danger: "#C10015",
      };
    },
  },
  methods: {
    $_goToDemandDetails({ isOverlayActive = false, demand }) {
      if (isOverlayActive) {
        // no action on overlay click
        return;
      }
      EventManager.emit(ETAB_EVENTS.RECRUITMENT.GO_TO_DETAILS, { recruitment: demand });
    },
    $_cancelDemandRelaunch(demand) {
      // if we don't want to restart the demand, it means we cancel it
      EventManager.emit(ETAB_EVENTS.RECRUITMENT.CANCEL, { recruitment: demand });
    },
    $_relaunchDemand(demand) {
      EventManager.emit(ETAB_EVENTS.RECRUITMENT.RESTART, { recruitment: demand });
    },
    $_shouldShowDetailsLink({ hasDemandStarted, isOverlayActive }) {
      return hasDemandStarted || isOverlayActive;
    },
    $_permanentjobFeedback(demand) {
      EventManager.emit(ETAB_EVENTS.RECRUITMENT.CDI_REVIEW, { recruitment: demand });
    },
    $_goToPermanentFeedback(hasRecruited = false) {
      EventManager.emit(ETAB_EVENTS.RECRUITMENT.GO_TO_PERMANENT_FEEDBACK, { recruitment: this.demand, hasRecruited });
    },
    $_hideExpirationPermanentDemand(demand) {
      return !demand.isUnlocked() || demand.isExpired();
    },
    $_hideExpirationTemporaryDemand({ demand, isOverlayActive }) {
      return demand.isFilled() || isOverlayActive || demand.hasStarted();
    },
    $_showDetailsLink({ demand, isOverlayActive }) {
      return demand.hasStarted() || isOverlayActive;
    },
    $_shouldDisplayDemandStatus(demand = new RecruitmentDashboardModel()) {
      return demand.isFilled() || demand.isBookingExpress() || !demand.getCandidateCancellationCount() || !demand.getSelectedCandidateAmount();
    },
    async $_duplicateDemand(templateId, isPosthogCreationEventEnabled) {
      try {
        const data = await CreationDemandService.duplicateAEDemand(templateId);
        const newTemplateId = data.id;
        const nextStepSlug = data.next_step || TEMPLATE_CREATION_STEPS.SUMMARIZE;
        if (this.$posthog && isPosthogCreationEventEnabled) {
          const clientType = UserStorageManager.getClientType();
          this.$posthog.capture("template_duplicated", { $template: newTemplateId, $client_type: clientType });
        }
        this.$router
          .push({ name: ETAB_ROUTES.creation.funnel.step.slug.name, params: { templateId: newTemplateId, stepSlug: nextStepSlug } })
          .catch((suppressedError) => {});
      } catch (error) {
        NotificationsManager.error();
      }
    },
  },
};
